import Foundation from './Foundation';

export default Foundation;